<template>
  <LayoutSideImage :image="BackgroundImage">
    <RouterView />
  </LayoutSideImage>
</template>

<script setup lang="ts">
import BackgroundImage from '@/assets/images/auth-background.jpg'
import LayoutSideImage from '@/components/layout/LayoutSideImage.vue'
</script>
